import { render } from "./Carrinho.vue?vue&type=template&id=dc19b728&scoped=true"
import script from "./Carrinho.vue?vue&type=script&lang=js"
export * from "./Carrinho.vue?vue&type=script&lang=js"

import "./Carrinho.vue?vue&type=style&index=0&id=dc19b728&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc19b728"]])

export default __exports__